import { createUuid } from '@/utils/common'
let OSS = require('ali-oss');
let client = new OSS({
  region: process.env.VUE_APP_OSS_REGION,
  accessKeyId: process.env.VUE_APP_OSS_KEYID,
  accessKeySecret: process.env.VUE_APP_OSS_KEYSECRET,
  bucket: process.env.VUE_APP_OSS_BUCKET,
});

let fileOperation= {

  //上传
  //objectUrl文件路径，file文件
  putFile(file) {
    try {
      let fileUuid = createUuid();
      let suffix = file.name.split('.')[file.name.split('.').length - 1];
      let result = client.put('image/'+fileUuid + '.' + suffix, file);
      console.log(result);
      result.fileName = fileUuid + '.' + suffix;
      return result;
    } catch (err) {
      console.log(err,"上传err");
    }
    return '';
  },
}

export default fileOperation;
